import InputDrop from "../../../../components/InputDrop";
import React from "react";
import Modal from "components/Modal";
import cls from "./modal.module.scss";
import { Button } from "@duik/it";
import className from "classnames";
export const AssessmentUpload = ({ handleClose, isOpen, onClickExport, downloadPdfButton, landscapePDFDownloadButton }) => {
    const [format, setFormat] = React.useState("PDF (Vertical)");
    const items = [
        { label: "PDF (Vertical)", value: 0 },
        { label: "PDF (Horizontal)", value: 1 },
    ]
    const initOption = format === "PDF (Vertical)" ? items[0] : items[1];
    return (
        <Modal
            isOpen={isOpen}
            handleClose={handleClose}
            className={cls.modalWrapper}
        >
            <h2>Export product list</h2>
            <div>
                <InputDrop
                    label="EXPORT FORMAT"
                    handleChange={(e) => {
                        setFormat(e.label);
                    }}
                    name="format"
                    items={items}
                    defaultOption={initOption}
                />
            </div>
            <div>
                {format === 'PDF (Horizontal)' ? landscapePDFDownloadButton : downloadPdfButton}
            </div>
            <div>
                <Button
                    className={className(cls.button, cls.cancelBtn)}
                    onClick={handleClose}
                >
                    CANCEL
                </Button>
            </div>
        </Modal>
    );
};

export default AssessmentUpload;
